
export default {
  root: {
    border: 'none',
  },
};

